import { type Actions, ActionType } from './profile.actions';
import { initialState, type State } from './profile.state';

export function profileReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_CURRENT_USER: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_CURRENT_USER_SUCCEEDED: {
            return {
                ...state,
                currentUser: action.payload.user,
                isPending: false,
                isCurrentUserLoaded: true
            };
        }

        case ActionType.FETCH_CURRENT_USER_FAILED: {
            return {
                ...state,
                isPending: false,
                isCurrentUserLoaded: false
            };
        }

        case ActionType.SET_RIGHTS: {
            return {
                ...state,
                rights: action.payload.rights,
                areRightsLoaded: true
            };
        }

        case ActionType.UPDATE_CURRENT_USER: {
            if (!state.currentUser) {
                return state;
            }
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    ...action.payload.userUpdate
                }
            };
        }

        case ActionType.SET_IS_PENDING: {
            return {
                ...state,
                isPending: action.payload
            };
        }

        case ActionType.RESET_RIGHTS: {
            return {
                ...state,
                rights: [],
                areRightsLoaded: false
            };
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        default:
            return state;
    }
}
